import React from "react";
import Layout from "../../layouts/index";
import VehicleTypeScreen from "../../screens/onbording_web/VehicleType";

const VehicleType = () => {
  return (
    <Layout>
      <VehicleTypeScreen />
    </Layout>
  );
};

export default VehicleType;
